<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Downloads",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
    };
  },
  methods: {
    
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Download Setup</h5>
                  <p class="fw-bold">Enter Work Email to Activate</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo-blue.png" alt height="48" />
                  </span>
                </div>
              </router-link>
            </div>

            <div class="p-2">
              <div class="row">
          <div class="col-12 mb-2">
              <h4 class="mb-4">{{ $t('menuitems.dashboards.data.settings.systemRequirements') }}</h4>
              <p><i class="bx bxl-windows font-size-17 me-2"></i> Windows   : <span class="fw-bold">7, 8, 10, 11</span></p>
              <p><i class="fab fa-apple font-size-17 me-2"></i> Mac   : <span class="fw-bold">Mac OS X or newer</span></p>
              <p><i class="bx bx-chip font-size-17 me-2"></i> RAM  : <span class="fw-bold">{{ $t('menuitems.dashboards.data.settings.mininmum') }} 2GB</span></p>
              <p><i class="bx bxl-edge font-size-17 me-2"></i> .NET : <span class="fw-bold">4.5 {{ $t('menuitems.dashboards.data.settings.andAbove') }} (for Windows Only)</span></p>
              <div class="row">
              <a target="_blank" href="https://workrhythm.net/download/WRSetup.exe" class="btn btn-info col-md-6">{{ $t('menuitems.dashboards.data.settings.downloadFor') }} Windows <i class="bx bxl-windows font-size-18"></i></a>
              <a href="https://workrhythm.net/download/WorkRhythm.pkg" class="btn btn-success col-md-5 ms-3">{{ $t('menuitems.dashboards.data.settings.downloadFor') }} Mac <i class="fab fa-apple font-size-18"></i></a>
              </div>
          </div>
        </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p class="fw-bold">
            Need Help ?
            <a target="_blank"
              href="https://workrhythm.net/download/WorkRhythm-Installation-Guide.pdf"
              class="fw-medium text-primary"
              >Download Installation Guide</a
            >
          </p>
          <!--<p>
            © {{ new Date().getFullYear() }} Skote. Crafted with
            <i class="mdi mdi-heart text-danger"></i> by Themesbrand
          </p>-->
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
